
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { EditButton } from '../../components';
import './index.scss';
import DataTable from 'react-data-table-component';
import ActiveDotIcon from '../LiveProject/ActiveDotIcon';
import { useState } from 'react';
import { useEffect } from 'react';
// import projectTest from "../../assets/images/projecttestimg.svg";
import infoSvgIcon from '../../assets/images/infoLiveTableIcon.svg';

const { urlBase } = window.runConfig;

function ProcessingProjectData(props) {
  const src =
    urlBase + 'api/v1/labels/' + props.labelId + '?display_image=true';
  const [latestData, setLatestData] = useState([]);
  const history = useHistory();

  const edit = (row) => {
    history.push({
      pathname: '/dashboard/editProject',
      state: { project: row },
    });
  };
  const columnss = [
    {
      name: 'Product Image',
      // selector: (row) => row.label,
      width: '10%', // Adjust the width percentage as needed
      cell: (row) => {
        const src =
          urlBase + 'api/v1/labels/' + row?.labels[0]?.id ? row?.labels[0]?.id : null + '?display_image=true';
        return (
          <div style={{ width: '100%', margin: '14px 0px' }}>
            <img
              alt="display"
              objectfit="cover"
              width="93px"
              height="83px"
              style={{
                borderRadius: '15px',
                backgroundColor: '#C4C4C4',
                backgroundSize: 'cover',
              }}
              src={src}
            />
          </div>
        );
      },
    },
    {
      name: 'Product Details',
      selector: (row) => row?.id ? row?.id : null,
      sortable: true,
      width: '75%',
      cell: (row, index) => {
        return (
          <div className="d-flex flex-column">
            <p
              style={{
                color: '#090B0B',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '18px',
                margin: '0px',
              }}
            >
              {row?.name ? row?.name : ""}
            </p>
            <p
              style={{
                color: '#090B0B',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '18px',
                margin: '0px',
              }}
            >
              {' '}
              {row?.description ? row?.description : ""}
            </p>
          </div>
        );
      },
    },
    {
      name: 'Status',
      cell: (row) => {
        return (
          <div style={{ color: '#0060F0' }}>
            <span
              style={{
                backgroundColor: '#F2F7FE',
                padding: '2px 6px',
                borderRadius: '16px',
                display: 'block',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                fontFamily: 'Inter',
                fontWeight: 400,

                fontSize: '10px',
              }}
            >
              <ActiveDotIcon fill={'#0060F0'} /> In Progress
            </span>
          </div>
        );
      },
    },

    {
      name: '',
      cell: (row) => {
        return (
          <div className="btns-div">
            <div className="bottom-buttons">
              <EditButton onclick={() => edit(row)} />
            </div>
            <div style={{ marginTop: '10px' }}>
              <Link
                className="links"
                to={{
                  pathname: '/dashboard/project',
                  state: { projectId: row?.id ? row?.id : "" },
                }}
              >
                <img
                  style={{ cursor: 'pointer' }}
                  src={infoSvgIcon}
                  alt="info"
                />
              </Link>
            </div>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    let newData = props?.newProjectData?.filter(
      (el) =>
        el?.labels?.length > 0 &&
        el?.labels[0]?.provisioning_status === 'PROCESSING'
    );
    setLatestData(newData);
  }, [props.newProjectData]);
  const tableCustomStyles = {
    headCells: {
      style: {
        fontSize: '12px',
        fontWeight: '400',
        justifyContent: 'start',
        lineHeight: '18px',
        fontFamily: 'Inter',
        color: 'rgba(0, 0, 0, 0.40)',
        opacity: 1,
      },
    },
    cells: {
      style: {
        display: 'flex',
        justifyContent: 'start',
      },
    },
  };
  return (
    // <tr key={props.id}>
    //   <td>
    //     <img
    //       alt="display"
    //       objectfit="cover"
    //       width="93px"
    //       height="83px"
    //       style={{
    //         borderRadius: '15px',
    //         backgroundColor: '#C4C4C4',
    //         backgroundSize: 'cover',
    //       }}
    //       src={src}
    //     />
    //   </td>
    //   <td>
    //     <div className="d-flex flex-column">
    //       <p
    //         style={{
    //           paddingBottom: '0rem',
    //           marginBottom: 0,
    //           fontWeight: 500,
    //           paddingTop: '0.7rem',
    //         }}
    //       >
    //         {props.projectname}
    //       </p>
    //       <p
    //         style={{
    //           color: '#42444A',
    //           fontWeight: '300',
    //           fontSize: '14px',
    //           lineHeight: '16px',
    //           maxWidth: '350px',
    //         }}
    //       >
    //         {' '}
    //         {props.description}
    //       </p>
    //     </div>
    //   </td>
    //   <td style={{ color: props.status === 'Active' ? '#1E8C0E' : '#BCBFC9' }}>
    //     {props.status}
    //   </td>
    //   <td>
    //     <div className="btns-div">
    //       <div className="bottom-buttons">
    //         <EditButton onclick={edit} />
    //       </div>
    //     </div>
    //   </td>
    //   <td>
    //     <Link
    //       className="links"
    //       to={{
    //         pathname: '/dashboard/project',
    //         state: { projectId: props.id },
    //       }}
    //     >
    //       .&nbsp;.&nbsp;.
    //     </Link>
    //   </td>
    // </tr>
    <>
      <DataTable
        columns={columnss}
        data={props.newProjectData}
        responsive
        customStyles={tableCustomStyles}
        // sortIcon={customSortIcon}
        // sortIcon={<SortIcon />}
      />
    </>
  );
}

export { ProcessingProjectData };

